import withStyles from "@material-ui/core/styles/withStyles";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Grid from "@material-ui/core/Grid";
import interestIcon from "Assets/Svg/interest-con.svg";
import "Module/Subscription/Recruit/index.scss";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class TeamStructure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      TeamStructures: [
        {
          value: 500,
          title: "Comprehensive health plans",
        },
      ],
    };
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleChange = (event, value, id) => {
    this.setState({ value, id }, () => {});
  };

  handleTabChange(value) {
    this.setState({
      value,
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { value } = this.state;
    return (
      <div style={{ marginBottom: 64 }}>
        <Grid container style={{ marginBottom: 24 }}>
          <Grid item xs={12} md={12} sm={12}>
            <p className="small-dark-secondary margin-bottom-16">
              TEAM STRUCTURE
            </p>
            <h6 className="section-title">Teamwork makes the dream work</h6>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          className="thumbnails"
          style={
            this.state.TeamStructures.length < 2
              ? { justifyContent: "flex-start" }
              : { justifyContent: "center" }
          }
        >
          {this.state.TeamStructures.map((teamstructure) => (
            <Grid item xs={12} md={3} sm={12} className="text-center">
              <h3
                className="t-bold margin-top-0 margin-bottom-8"
                style={{ color: "rgba(1,7,9,0.7)", fontSize: 48 }}
              >
                {teamstructure.value}
              </h3>
              <p className="normal-blue margin-bottom-32">
                {teamstructure.title}
              </p>
            </Grid>
          ))}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(TeamStructure)));
